// Shared Site Settings types + fallbacks (pure module — safe to import from
// both server and client). Values come from the WP ACF "Site Settings" options
// page (RootQuery.siteSettings); fallbacks preserve the prior hard-coded values
// so nothing regresses if WP is unreachable or a field is empty.

export interface SocialLink {
  platform: string;
  url: string;
}

export interface SiteSettings {
  phone: string;
  email: string;
  address: string;
  hours: string;
  copyright: string;
  socialLinks: SocialLink[];
}

export const SITE_SETTINGS_FALLBACK: SiteSettings = {
  phone: '+1 313 288 0062',
  email: 'passengerrecovery@gmail.com',
  address: '',
  hours: '',
  copyright: 'Passenger is a 501(c)(3) non-profit.',
  socialLinks: [
    {
      platform: 'Facebook',
      url: 'https://www.facebook.com/passengerrecovery/',
    },
    {
      platform: 'Instagram',
      url: 'https://www.instagram.com/passengerrecovery/',
    },
    { platform: 'Twitter', url: 'https://twitter.com/PassengerRec/' },
  ],
};
